<div class="row" *ngIf="!hasLoadedAssessment">
  <div class="col-xs-12">
    <p class="alert alert-warning"><app-spin-icon></app-spin-icon> Loading Assessment data...</p>
  </div>
</div>
<div class="row" *ngIf="hasLoadedAssessment">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">{{assessment.name}}</h2>
  </div>
</div>
<div class="row">
  <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color'" [contentClass]="'card'" class="col-12">
    <mdb-tab heading="Details">
      <dac-assessment-details-view [assessment]="assessment"></dac-assessment-details-view>
    </mdb-tab>
    <mdb-tab heading="Scales">
      <dac-scales-list-view [assessment]="assessment"></dac-scales-list-view>
    </mdb-tab>
    <mdb-tab heading="Question Sets">
      <dac-question-set-list-view [assessment]="assessment"></dac-question-set-list-view>
    </mdb-tab>
  </mdb-tabset>
<div>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-view/assessment-view.component.html